<div *ngIf="isGenerating">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
</div>
<div class="alert alert-red is-active container" *ngIf="error">
    {{ errorMessage }}
</div>
<div class="bootstrap-wrapper">
    <div class="reportContainer sd-bridge-summary-report" *ngIf="!error && reportData" id="onemap-report">
        <div class="squareReportSectionHeader">
            <label>Poor Bridge Condition Summary Report</label><label style="margin-right:10px;" class="pull-right">{{ todaysDate }}</label>
        </div>
        <div class="bridgeSummaryTableSection">
            <table class="bridgeSummaryTable table-condensed" aria-label="Poor Bridge Condition Summary Report">
                <thead>
                    <tr>
                        <th>Bridge Owner</th>
                        <th>Structurally Deficient</th>
                        <th>Structurally Deficient Deck Area (sq. ft)</th>
                        <th>Non Structurally Deficient</th>
                        <th>Non Structurally Deficient Deck Area (sq. ft)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of reportData.projects">
                        <td ng-class="{'numericCell' : $index > 0}">{{ row.owner }}</td>
                        <td ng-class="{'numericCell' : $index > 0}">{{ row.structurallyDeficient }}</td>
                        <td ng-class="{'numericCell' : $index > 0}">{{ row.structurallyDeficientDeckArea }}</td>
                        <td ng-class="{'numericCell' : $index > 0}">{{ row.nonStructurallyDeficient }}</td>
                        <td ng-class="{'numericCell' : $index > 0}">{{ row.nonStructurallyDefDeckArea }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
